<template>
    <div class="flex mb-px draggable relative">
        <div class="flex flex-1 m-0 relative">
            <div class="w-28 -ml-px flex">
                <ui-dropdown menu-class="p-3 w-auto" ref="dropdown">
                    <template #default="{ open,close }">
                        <page-cell
                            class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                            placeholder="Date..."
                            ref="date"
                            v-model="line.date"
                            @focus="open"
                            @input="updateDate(false)"
                            @blur="updateDate(true); close"
                        ></page-cell>
                    </template>
                    <template #menu="{ close }">
                        <ui-date-picker
                            class="text-sm -my-px ml-0"
                            field="absolute hidden"
                            placeholder="Date..."
                            :inline="true"
                            ref="datepicker"
                            v-model="line.date"
                            @input="updateDateFromPicker()"
                        ></ui-date-picker>
                    </template>
                </ui-dropdown>
            </div>
            <div class="w-20 -ml-px flex">
                <page-cell
                    class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                    placeholder="Qty..."
                    ref="quantity"
                    v-model="line.quantity"
                    @input="updateQuantity(false)"
                    @blur="updateQuantity(true)"
                ></page-cell>
            </div>
            <div class="-ml-px flex-grow">
                <page-cell
                    class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                    placeholder="Notes..."
                    ref="notes"
                    v-model="line.notes"
                    @input="updateNotes(false)"
                    @blur="updateNotes(true)"
                ></page-cell>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 bg-white border-t -mt-px border-gray-200">
            <ui-dropdown menu-class="p-3 w-72">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded mt-1.5">
                        <i class="fa fa-ellipsis-h fa-fw pl-1 pr-1"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <template>
                        <ui-dropdown-item icon="fas fa-trash" danger
                                          @click="$emit('removeItem',line);close();">
                            Remove Delivery Line
                        </ui-dropdown-item>
                    </template>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import PageCell from "../../ui/PageCell.vue";
import moment from "moment";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";

export default {
    components: {
        UiDatePicker,
        UiDropdownItem,
        UiDropdown,
        PageCell
    },
    props: {
        line: Object,
        rfmItem: Object,
    },
    data() {
        return {
            search: "",
            searching: false,
            moment: moment,
        }
    },
    watch: {},
    computed: {},
    methods: {
        updateQuantity(finished) {
        },
        updateDate(finished) {
        },
        updateNotes(finished) {
        },
        updateDateFromPicker(e) {
            this.$refs.dropdown.close()
        },
    },
    mounted() {
    }
}
</script>